import React, { useEffect, useRef } from "react";
import Scrollspy from "react-scrollspy";
import { IoClose } from "react-icons/io5";
const Nav = ({ links, setNav }) => {
  const navRef = useRef();
  useEffect(() => setNav(() => navRef.current), [setNav]);
  return (
    <nav
      className="mb-nav z-20 text-light font-['Poppins'] text-lg"
      ref={navRef}
    >
      <div
        className="close-mb-nav border border-borderColor rounded-full w-fit mx-12  p-3 mb-8 cursor-pointer hover:bg-light hover:text-dark"
        onClick={() => {
          navRef.current.classList.toggle("active");
          document.body.style = "overflow:auto";
        }}
      >
        <IoClose className="text-2xl" />
      </div>
      <Scrollspy
        items={links}
        currentClassName="menu-active"
        style={{ display: "flex", gap: "2.5rem" }}
      >
        {links.map((link, index) => {
          return (
            <li
              key={index}
              className="hover:text-dark transition-colors duration-300"
            >
              <a
                className="inline-block w-full"
                href={`#${link.toLowerCase()}`}
                onClick={() => {
                  navRef.current.classList.toggle("active");
                  document.body.style = "overflow:auto";
                }}
              >
                {link[0].toUpperCase() + link.slice(1).toLowerCase()}
              </a>
            </li>
          );
        })}
      </Scrollspy>
    </nav>
  );
};

export default Nav;
